import request from "@/utils/request";

/* 验证码 */
export function getSmsCode(data: {
  mobile: string;
  scene: number;
}): Promise<boolean> {
  return request.post("/member-api/system/auth/send-register-sms-code", data);
}

interface IRegiste {
  username: string;
  password: string;
  mobile: string;
  contact: string;
  registerSmsCode: string;
  code: string;
}
/* 用户注册 */
export function registeAccount(data: IRegiste): Promise<boolean> {
  return request.post("/member-api/system/user/channel-register", data);
}

export function getLoginQrcode(): Promise<any> {
  return request.get(`/app-api/mp/login/getLoginQrCode`);
}

export function checkWeixinToken(token:string): Promise<any> {
  return request.post(`/app-api/mp/login/check-weixin-token/${token}`);
}

export interface ILoginData {
  accessToken: string;
  expiresTime: number;
  refreshToken: string;
  userId: number;
}

/* 登录(账号密码) */
export function accountLogin(data: {
  username: string;
  password: string;
}): Promise<ILoginData> {
  return request.post("/member-api/system/auth/login", data);
}

interface IResetParams {
  username: string;
  mobile: string;
  registerSmsCode: string;
  password: string;
}
/* 重置密码 */
export function resetPassword(data: IResetParams): Promise<boolean> {
  return request.post("/member-api/system/user/reset-password", data);
}

export function toSAAS(id: number): Promise<string> {
  return request.get("/member-api/saas/login?id=" + id);
}
